export const invoiceList = {
  head: {
    title: "Rechnungswesen",
    subtitle: "An Ihre Gäste ausgestellte Rechnungen",
  },
  stats: {
    filterAria: "Rechnungen nach Status filtern",
    total: "Gesamt",
    draft: "Entwürfe",
    sent: "Ausgestellt",
    processing: "In Bearbeitung",
    error: "Mit Fehlern",
    pending: "Ausstehend",
    voided: "Storniert",
  },
  toolbar: {
    searchLabel: "Rechnungen suchen",
    searchPlaceholder: "Rechnungsnr., Kunde, E-Mail, Steuernummer oder Buchung…",
    clearSearch: "Suche leeren",
    propertyLabel: "Unterkunft",
    allProperties: "Alle Unterkünfte",
    typeToSearchProperties: "Tippen Sie, um Unterkünfte zu suchen.",
    noProperties: "Keine Unterkünfte gefunden.",
    statusLabel: "Status",
    emisorLabel: "Aussteller",
    allEmisores: "Alle Aussteller",
    servicesTitle: "Katalog wiederverwendbarer Leistungen und Services",
    services: "Leistungen und Services",
    createInvoice: "Rechnung erstellen",
  },
  exportZip: {
    button: "ZIP",
    title: "Eine Datei pro Rechnung, jede mit Datum und Buchungscode, alle in einer ZIP-Datei",
    generating: "Wird erstellt…",
    zipping: "Wird komprimiert…",
    noPdfInPeriod: "Im Zeitraum gibt es keine ausgestellten Rechnungen mit PDF.",
    noPdfInPage: "Auf dieser Seite gibt es keine ausgestellten Rechnungen mit PDF.",
    tooMany: "Die Auswahl enthält {total} Rechnungen, die ZIP-Datei erlaubt {limit}. Schränken Sie den Zeitraum oder die Filter ein.",
    noneDownloaded: "Es konnte keine Rechnung von Invopop heruntergeladen werden. Versuchen Sie es in einigen Minuten erneut.",
    failed: "{n} Rechnung(en) konnten nicht von Invopop heruntergeladen werden: {codes}.",
    withoutPdf: "{n} Rechnung(en) haben noch kein PDF in Invopop und sind nicht in der ZIP-Datei: {codes}.",
    restIncluded: "Alle übrigen sind in der ZIP-Datei.",
    error: "Die ZIP-Datei mit den Rechnungen konnte nicht erstellt werden.",
  },
  linkedClient: {
    prefix: "Rechnungen verknüpft mit",
    fallbackName: "diesem Rechnungskunden",
    clear: "Kundenfilter entfernen",
  },
  table: {
    numberHeader: "RECHNUNGSNR.",
    customerHeader: "KUNDE",
    propertyHeader: "UNTERKUNFT",
    totalHeader: "GESAMT",
    statusHeader: "STATUS",
    dateHeader: "DATUM",
    actionsHeader: "AKTIONEN",
    draftReferenceTitle: "Referenz des Entwurfs. Die Steuernummer wird bei der Ausstellung vergeben.",
    openReserva: "Buchung öffnen",
    viewCreditNote: "Korrekturrechnung {code} ansehen",
    creditNote: "Korrekturrechnung",
    viewError: "Fehler ansehen",
    voids: "Storniert",
    correctionOf: "Korr. von",
    correctedBy: "Korrigiert durch:",
  },
  sortFields: {
    number: "Rechnungsnummer",
    customer: "Kunde",
    property: "Unterkunft",
    total: "Gesamt",
    status: "Status",
    date: "Datum",
  },
  sort: {
    sortBy: "Nach {label} sortieren",
    sortedBy: "Sortiert nach {label}, {direction}. Reihenfolge ändern",
    asc: "aufsteigend",
    desc: "absteigend",
  },
  actions: {
    openPdf: "Rechnung als PDF öffnen",
    editDraftTitle: "Kundendaten und Positionen bearbeiten",
    edit: "Bearbeiten",
    previewTitle: "Vorschau ohne steuerliche Gültigkeit öffnen",
    preview: "Vorschau",
    sendQuote: "Angebot",
    sendQuoteTitle: "Das Angebot per E-Mail an den Kunden senden",
    emitTitle: "Rechnung prüfen und ausstellen",
    emit: "Ausstellen",
    syncTitle: "Rechnungsstatus aktualisieren",
    sync: "Aktualisieren",
    retryTitle: "Mit aktualisierten Rechnungsdaten erneut versuchen",
    retry: "Erneut versuchen",
    moreOptions: "Weitere Optionen",
    moreOptionsAria: "Weitere Rechnungsoptionen",
    editCustomer: "Kundendaten bearbeiten",
    deleteReset: "Löschen und Anfrage zurücksetzen",
    voidReissue: "Stornieren und neu ausstellen",
  },
  empty: {
    searchTitle: "Keine Rechnungen gefunden",
    searchText: "Keine Ergebnisse passen zur aktuellen Suche und zu den Filtern.",
    clearFilters: "Filter leeren",
    title: "Noch keine Rechnungen",
    text: "Erstellen Sie einen Entwurf und stellen Sie ihn aus, sobald Steuerdaten und Leistungen bereit sind.",
    createFirst: "Erste Rechnung erstellen",
  },
  errorModal: {
    title: "Rechnungsfehler",
    hintBefore: "Wenn der Fehler in Ihren Rechnungsdaten liegt (Steuernummer, Serie…), korrigieren Sie sie unter",
    hintSettingsPath: "Einstellungen → Rechnungswesen",
    hintBetween: "und verwenden Sie dann",
    hintRetryWord: "Erneut versuchen",
    hintGuest: "Wenn der Fehler in den Daten des Gastes liegt, verwenden Sie",
    hintEditWord: "Kundendaten bearbeiten",
    close: "Schließen",
    retryNow: "Jetzt erneut versuchen",
  },
  editCustomer: {
    title: "Kundendaten bearbeiten",
    subtitle: "Korrigieren Sie die Daten und versuchen Sie die Rechnung erneut",
    name: "Name / Firmenname *",
    taxId: "Steuernummer / USt-IdNr.",
    country: "Land (2-stelliger Code) *",
    email: "E-Mail *",
    address: "Adresse",
    city: "Stadt",
    zip: "Postleitzahl",
    hint: "Beim Speichern wird der Versand der Rechnung automatisch erneut versucht.",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    save: "Speichern und erneut versuchen",
  },
  deleteConfirm: {
    title: "Rechnung löschen",
    body1: "Dieser Rechnungsversuch wird gelöscht und die",
    bodyStrong: "Anfrage des Gastes wird zurückgesetzt",
    body2: ", sodass er seine Daten erneut eingeben und die Rechnung erneut anfordern kann.",
    irreversible: "Diese Aktion kann nicht rückgängig gemacht werden.",
    cancel: "Abbrechen",
    deleting: "Wird gelöscht…",
    confirm: "Ja, löschen",
  },
  create: {
    titleEdit: "Entwurf bearbeiten",
    titleCreate: "Rechnung erstellen",
    subtitleEdit: "Aktualisieren Sie Kunde, Kontext und Positionen. Die Rechnung wird nicht ausgestellt.",
    subtitleCreate: "Entwurf: keine Nummer bis zur Ausstellung. Keine Buchung erforderlich.",
    loading: "Entwurf wird geladen…",
    clientLabel: "Kunde *",
    clientHelp: "Wählen Sie ein gespeichertes Rechnungsprofil aus oder legen Sie ein neues an.",
    newClient: "Neuer Kunde",
    company: "Unternehmen",
    individual: "Privatperson",
    change: "Ändern",
    clientSearchPlaceholder: "Nach Name, E-Mail oder Dokument suchen…",
    incomplete: "Unvollständig",
    noClients: "Keine Kunden gefunden.",
    createClient: "Kunde anlegen",
    contextTitle: "Kontext der Rechnung",
    optional: "Optional",
    contextHelp: "Verknüpfen Sie diese Rechnung, um die Nachvollziehbarkeit zu wahren. Sie können beide Felder leer lassen.",
    propertyLabel: "Unterkunft",
    propertyPlaceholder: "Unterkunft suchen…",
    typeToSearchProperties: "Tippen Sie, um Unterkünfte zu suchen.",
    noProperties: "Keine Unterkünfte gefunden.",
    reservationLabel: "Buchung",
    reservationPlaceholder: "Code, Gast, E-Mail suchen…",
    noHolder: "Kein Inhaber",
    typeToSearchReservations: "Tippen Sie, um Buchungen zu suchen.",
    noReservations: "Keine Buchungen gefunden.",
    contextNotice: "Die Buchung legt die Unterkunft fest und fügt den Aufenthalt hinzu, sofern er noch nicht abgerechnet wurde.",
    chargesTitle: "Leistungen und Services",
    chargesHelp: "Wählen Sie in Ihrem Katalog gespeicherte Positionen aus.",
    addCharge: "Leistung oder Service hinzufügen",
    colConcept: "Position",
    colQty: "Anz.",
    colUnitPrice: "Einzelpreis",
    colTotal: "Gesamt",
    docTitle: "So wird die Rechnung aussehen",
    docHint: "Das sind die Zeilen, die das PDF enthalten wird. Unterkunft, Rabatte und automatische Posten stammen aus der Buchung: oben bearbeiten Sie nur Ihre eigenen Katalogposten.",
    due: "Offener Betrag",
    assumed: "Für diese Buchung sind keine Zahlungen erfasst. Der Betrag gilt anhand der gewählten Zahlungsart als bezahlt, und im PDF steht dasselbe.",
    linesEmpty: "Fügen Sie eine oder mehrere Positionen aus Ihrem Katalog hinzu.",
    total: "Gesamt",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    saveChanges: "Änderungen speichern",
    saveDraft: "Entwurf speichern",
  },
  contextSummary: {
    property: "Unterkunft ausgewählt",
    empty: "Unterkunft oder Buchung hinzufügen",
  },
  emit: {
    title: "Rechnung ausstellen",
    subtitle: "Mit dieser Aktion wird die endgültige Steuernummer vergeben.",
    client: "Kunde",
    property: "Unterkunft",
    total: "Gesamt",
    warning: "Nach der Ausstellung können Sie die Rechnung nicht mehr direkt bearbeiten; jede Korrektur erfordert ein Korrekturdokument.",
    cancel: "Abbrechen",
    emitting: "Wird ausgestellt…",
    confirm: "Rechnung ausstellen",
  },
  editDraft: {
    title: "Entwurf bearbeiten",
    subtitle: "Ändern Sie die Kundendaten und Positionen. Die Rechnung wird nicht ausgestellt.",
    loading: "Entwurf wird geladen…",
    individual: "Privatperson",
    individualSub: "Natürliche Person",
    company: "Unternehmen",
    companySub: "Juristische Person",
    legalName: "Firmenname *",
    fullName: "Vollständiger Name *",
    companyNamePlaceholder: "Name des Unternehmens",
    individualNamePlaceholder: "Vor- und Nachname",
    country: "Land *",
    docCompany: "Steuernummer des Unternehmens (USt-IdNr.)",
    docIndividual: "Ausweis / Reisepass",
    docCompanyPlaceholder: "USt-IdNr. / Steuernummer",
    docIndividualPlaceholder: "Personalausweis oder Reisepass",
    email: "E-Mail",
    emailOptional: "(optional)",
    lodgingTitle: "Unterkunft",
    lodgingName: "Unterkunft",
    lodgingNoteBefore: "Aus der Buchung übernommen",
    lodgingNoteAfter: ". Um diesen Betrag zu ändern, bearbeiten Sie ihn in der Buchung.",
    chargesTitle: "Leistungen und Services",
    chargesHelp: "Fügen Sie gespeicherte Positionen hinzu, ohne die Unterkunft zu verändern.",
    addCharge: "Leistung oder Service hinzufügen",
    colConcept: "Position",
    colQty: "Anz.",
    colUnitPrice: "Einzelpreis",
    colTotal: "Gesamt",
    linesEmpty: "Keine zusätzlichen Positionen.",
    linesEmptyReserva: "Die Rechnung umfasst nur die Unterkunft.",
    total: "Gesamt",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    saveChanges: "Änderungen speichern",
  },
  void: {
    doneTitle: "Rechnung storniert",
    doneSubtitle: "Korrekturrechnung erfolgreich ausgestellt",
    whatHappened: "Was ist passiert?",
    doneCreditNote: "Die Korrekturrechnung wurde ausgestellt",
    doneListed: "Die Rechnung bleibt in der Liste und ist als storniert markiert",
    doneCharges: "Die zusätzlichen Leistungen wurden freigegeben",
    doneGuest: "Der Gast kann seine Rechnung erneut anfordern",
    nextStepsLabel: "Nächste Schritte:",
    nextStepsText: "Sie können Leistungen zur Buchung hinzufügen oder korrigieren. Senden Sie anschließend den Rechnungslink erneut an den Gast.",
    understood: "Verstanden",
    title: "Rechnung stornieren und neu ausstellen",
    introBefore: "Mit dieser Aktion",
    introStrong: "wird die ausgestellte Rechnung",
    introAfter: "mittels einer offiziellen Korrekturrechnung storniert.",
    willEmit: "Es wird eine Korrekturrechnung ausgestellt",
    willList: "Die Rechnung bleibt in der Liste und ist als storniert markiert",
    willFree: "Die zusätzlichen Leistungen werden freigegeben",
    willAllowGuest: "Der Gast kann die Rechnung erneut anfordern",
    reasonLabel: "Grund für die Stornierung",
    reasonOther: "Anderer Grund…",
    reasonPlaceholder: "Erläutern Sie, warum Sie diese Rechnung stornieren",
    warning: "Die Korrekturrechnung ist ein offizielles Steuerdokument. Verwenden Sie sie nur, wenn Sie die Rechnung wirklich korrigieren müssen.",
    cancel: "Abbrechen",
    emitting: "Korrekturrechnung wird ausgestellt…",
    confirm: "Ja, stornieren und neu ausstellen",
  },
  statusFilters: {
    all: "Alle",
    draft: "Entwürfe",
    sent: "Ausgestellt",
    processing: "In Bearbeitung",
    error: "Mit Fehlern",
    pending: "Ausstehend",
    voided: "Storniert",
  },
  voidReasons: {
    wrongTaxData: "Falsche Steuerdaten des Kunden",
    wrongAmount: "Falscher Betrag oder falsche Leistungen",
    duplicate: "Doppelte Rechnung",
    cancelledReservation: "Buchung storniert",
    reissue: "Storniert, um mit korrigierten Daten oder Leistungen neu auszustellen",
  },
  statusLabels: {
    draft: "Entwurf",
    sent: "Ausgestellt",
    processing: "In Bearbeitung",
    error: "Fehler",
    pending: "Ausstehend",
    corrected: "Korrigiert",
    voided: "Storniert",
  },
  client: {
    fallbackName: "Kunde",
    fiscalPending: "Rechnungsprofil ausstehend",
    fiscalSaved: "Rechnungsprofil gespeichert",
  },
  reservation: {
    noCode: "Kein Code",
    noDates: "Keine Daten",
    noHolder: "Kein Inhaber",
    propertyFallback: "Unterkunft Nr. {id}",
  },
  emisorFallback: "Aussteller Nr. {id}",
  toasts: {
    selectClientComplete: "Wählen Sie einen Kunden mit vollständigem Rechnungsprofil aus.",
    selectReservationOrCharge: "Wählen Sie eine Buchung aus oder fügen Sie mindestens eine Leistung oder einen Service hinzu.",
    saveDraftError: "Der Entwurf konnte nicht gespeichert werden.",
    createError: "Die Rechnung konnte nicht erstellt werden.",
    quoteSent: "Angebot an {email} gesendet",
    quoteError: "Das Angebot konnte nicht gesendet werden.",
    previewError: "Die Vorschau konnte nicht erzeugt werden.",
    previewName: "Vorschau",
    emitRejected: "Die Steuerplattform hat die Ausstellung abgelehnt.",
    emitError: "Die Rechnung konnte nicht ausgestellt werden. Prüfen Sie die Steuerdaten und versuchen Sie es erneut.",
    selectClientToContinue: "Wählen Sie einen Kunden mit Rechnungsprofil aus, um fortzufahren.",
    loadDraftError: "Die Details des Entwurfs konnten nicht geladen werden.",
    nameRequired: "Geben Sie den Namen des Kunden ein.",
    countryRequired: "Wählen Sie das Land des Kunden aus.",
    selectCatalogCharge: "Wählen Sie mindestens eine Leistung oder einen Service aus dem Katalog aus.",
    retryError: "Der erneute Versuch ist fehlgeschlagen.",
    saveError: "Speichern nicht möglich.",
    voidError: "Die Rechnung konnte nicht storniert werden.",
    deleteError: "Löschen nicht möglich.",
  },
};
